// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import LoadingSpinner from "@insite/mobius/LoadingSpinner";
import Modal, { ModalProps } from "@insite/mobius/Modal";
import { StyledProp } from "@insite/mobius/utilities/InjectableCss";
import Button from "@store/MobiusOverrides/Button/Button";
import React from "react";
import styled from "styled-components";

const desktopQuery = "@media (min-width: 768px)";
export const ApiModal = styled(Modal)`
    && {
        & div[role="dialog"] {
            border-radius: 0.5rem;
            ${desktopQuery} {
                max-width: 95vw;
            }
        }
    }
`;
export const StyledSpinner = styled(LoadingSpinner)`
    && {
        font-size: 0.875rem !important;
        font-weight: 400;
        min-height: unset !important;
        padding: 0.4rem 0.625rem !important;
        margin-right: 0.25rem;
        margin-left: 2.5rem;
        & * {
            font-size: 0.875rem !important;
        }
    }
`;
export const ButtonReport = styled(Button)`
    && {
        font-size: 0.875rem !important;
        font-weight: 400;
        min-height: unset !important;
        padding: 0.4rem 0.625rem !important;
        margin-right: 0.25rem;
        margin-left: 0.25rem;
        & * {
            font-size: 0.875rem !important;
        }
    }
`;

interface Props {
    children: React.ReactNode;
    modalHeader: JSX.Element;
    onClick: () => Promise<boolean>;
    isData: boolean;
    isLoading: boolean;
    buttonText?: string;
    cssOverrides?: {
        scrim?: StyledProp<any>;
        modalContainer?: StyledProp<ModalProps>;
        modalBody?: StyledProp<ModalProps>;
        modalTitle?: StyledProp<ModalProps>;
        modalContent?: StyledProp<ModalProps>;
        headlineTypography?: StyledProp<ModalProps>;
        titleButton?: StyledProp<ModalProps>;
    };
}
const ApiDataModel: React.FC<Props> = ({
    children,
    modalHeader,
    onClick,
    isData,
    isLoading,
    cssOverrides,
    buttonText = translate("View Order Items"),
}) => {
    const [ApiModelDetailsIsOpen, setApiModelDetailsOpen] = React.useState(false);
    const modalCloseHandler = () => {
        setApiModelDetailsOpen(false);
    };
    const handleModalClick = async () => {
        const result = await onClick();
        if (result) {
            setApiModelDetailsOpen(true);
        }
    };
    return (
        <>
            {isLoading ? (
                <StyledSpinner size={50} />
            ) : (
                <ButtonReport data-test-selector="viewOrderItems_viewOrderItemsButton" onClick={handleModalClick}>
                    {buttonText}
                </ButtonReport>
            )}
            {isData && (
                <ApiModal
                    cssOverrides={cssOverrides}
                    headline={modalHeader}
                    isOpen={ApiModelDetailsIsOpen}
                    handleClose={modalCloseHandler}
                >
                    {children}
                </ApiModal>
            )}
        </>
    );
};
export default ApiDataModel;
